// @flow
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';

import PrintingCard from 'common/modules/printing/styles/PrintingCard';

import SingleMetric from '../../metrics/components/SingleMetric';

const SCard = styled(PrintingCard)`
  margin-top: ${({ theme }) => theme.metrics.margin}px;
`;

type Props = {
  metrics: {
    reach: number,
    listeningTime: number,
    listeningTimePerPerson: number,
  },
  t: any,
}

function DashboardPrintingWeeklyMetricsCard({ metrics, t }: Props) {
  return (
    <SCard>
      <SingleMetric title={t('reach')} value={metrics.reach} />
      <SingleMetric title={`${t('listeningTime')} (${t('hours')})`} value={metrics.listeningTime} />
      {metrics.listeningTimePerPerson &&
      <SingleMetric title={`${t('listeningTimePerPerson')} (${t('hours')})`} value={metrics.listeningTimePerPerson}
        roundAt={2}
      />
      }
    </SCard>
  );
}

export default withTheme(translate('dashboard')(DashboardPrintingWeeklyMetricsCard));



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/printing/DashboardPrintingWeeklyMetricsCard.js